import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      borderRadius: 0,
    },
    table: {
      '& th:first-child': {
        // borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },

      '& table': {
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(1, 2),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 2),
      },
      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
    },
    firstTd: {
      borderTopLeftRadius: 15,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    sortLabel: {
      color: '#fff !important',
    },
  }),
);

export default useStyles;
